import { useMutation, UseMutationOptions, UseMutationResult } from 'react-query';
import { AxiosError } from 'axios';
import { IOpenIdRedirect } from '@goparrot/dashboard-gateway-sdk';
import { squareSsoLoginRedirect } from '../utils/squareSsoLoginRedirect';

export const useSsoLogin = (options?: UseMutationOptions<IOpenIdRedirect, AxiosError>): UseMutationResult<IOpenIdRedirect, AxiosError> =>
  useMutation(squareSsoLoginRedirect, options);
